import { render, staticRenderFns } from "./SetupOverviewServer.vue?vue&type=template&id=a62d867a&scoped=true"
import script from "./SetupOverviewServer.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewServer.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverviewServer.vue?vue&type=style&index=0&id=a62d867a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62d867a",
  null
  
)

export default component.exports